var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showRedpacketPopup ? _c('div', {
    staticClass: "Layer-FullScreen component-redpacket-popup"
  }, [_c('div', {
    staticClass: "popup-redpacket-content"
  }, [_c('ycf-image', {
    staticClass: "redpacket-img",
    attrs: {
      "src": require("@/assets/img/entry_redpacket_bg.png")
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "content-title"
  }, [_vm._v("抵扣红包")]), _c('p', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.activityInfo.rewardMoney)), _c('span', [_vm._v("元")])]), _c('div', {
    staticClass: "open-btn",
    on: {
      "click": _vm.goRedpackageLanding
    }
  }, [_c('ycf-image', {
    staticClass: "active",
    attrs: {
      "src": require("@/assets/img/open-btn.png")
    }
  })], 1), _c('div', {
    staticClass: "not-notcie-today",
    on: {
      "click": _vm.handleNoticeChecked
    }
  }, [_c('svg', {
    staticClass: "icon checkbox-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm.noticeChecked ? _c('use', {
    attrs: {
      "xlink:href": "#icon-checkb"
    }
  }) : _c('use', {
    attrs: {
      "xlink:href": "#icon-nocheckb"
    }
  })]), _c('span', {
    staticClass: "text"
  }, [_vm._v("不再提醒")])])]), _c('div', {
    staticClass: "popup-close-btn",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.closePopUp.apply(null, arguments);
      }
    }
  })], 1)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };